const state = {
  canHost: false,
  hasHost:false
}

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {
  enableHost() {
    state.canHost = true;
  },
  hasHost(state, value) {
    state.hasHost = value;
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}